/**
 * EXC: "See more" for the collection description.
 *
 * The descriptions run 7 or 8 lines on a phone, which pushes product down the
 * screen. This clamps them and adds a toggle.
 *
 * The clamp class is printed in the HTML so the description is already short at
 * first paint (applying it here, after load, moved the product grid up 71px).
 * The text is always in the DOM, so nothing is hidden from search engines.
 *
 * Mobile only. From tablet up the description fits beside nothing and reads
 * fine at full length, so the clamp and the button come off.
 */

const MOBILE = '(max-width: 47.9275em)';
const CLAMP_CLASS = 'exc-clamp';
const OPEN_CLASS = 'is-open';

class ExcCollectionDescription {
  constructor(text) {
    this.text = text;
    this.button = null;
    this.open = false;

    this.mq = window.matchMedia(MOBILE);
    this.apply = this.apply.bind(this);

    if (!this.text.id) this.text.id = 'exc-collection-description';

    if (this.mq.addEventListener) {
      this.mq.addEventListener('change', this.apply);
    } else {
      this.mq.addListener(this.apply);
    }
    window.addEventListener('resize', this.debounced());

    this.apply();
  }

  debounced() {
    let timer = null;
    return () => {
      // setTimeout, not rAF: rAF never fires while the tab sits in the
      // background, which is how the preview pane sits during testing (trap 8).
      window.clearTimeout(timer);
      timer = window.setTimeout(this.apply, 150);
    };
  }

  apply() {
    if (!this.mq.matches) {
      this.teardown();
      return;
    }

    this.text.classList.add(CLAMP_CLASS);

    // Measure while closed, otherwise an open description never looks clamped.
    const wasOpen = this.open;
    if (wasOpen) this.text.classList.remove(OPEN_CLASS);
    const overflows = this.text.scrollHeight - this.text.clientHeight > 2;
    if (wasOpen) this.text.classList.add(OPEN_CLASS);

    if (!overflows) {
      // Short description. No clamp, no button.
      this.teardown();
      return;
    }

    if (!this.button) this.build();
    this.button.hidden = false;
  }

  build() {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'exc-collection-more js-exc-collection-more';
    button.setAttribute('aria-controls', this.text.id);
    button.addEventListener('click', () => this.toggle());
    this.text.insertAdjacentElement('afterend', button);
    this.button = button;
    this.setState(false);
  }

  toggle() {
    this.setState(!this.open);
  }

  setState(open) {
    this.open = open;
    this.text.classList.toggle(OPEN_CLASS, open);
    this.button.textContent = open ? 'See less' : 'See more';
    this.button.setAttribute('aria-expanded', String(open));
  }

  teardown() {
    this.text.classList.remove(CLAMP_CLASS, OPEN_CLASS);
    this.open = false;
    if (this.button) {
      this.button.hidden = true;
      this.button.setAttribute('aria-expanded', 'false');
    }
  }
}

const description = document.querySelector('.collection__header-info__text');
if (description && description.textContent.trim().length > 0) {
  new ExcCollectionDescription(description);
}
